import { INotification } from '../../models/Notification';

export type NotificationsState = INotification[];

export const notificationsState: NotificationsState = [];
